import { Box } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { useEffect, useState } from 'react';

import { Menu } from 'components/menu/containers/menu';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useBreakpointValue } from 'utils/mediaQuery';
import { pubSub } from 'utils/pubSub';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { OrganizationsNavigation } from './components/organizationsNavigation/organizationsNavigation';
import styles from './navigation.module.scss';

/** Left side main app layout navigation component */
export const Navigation = ({ className }: PropsWithClassName): JSX.Element => {
  const { organizationsSidebar } = useFeatureFlag(['organizations-sidebar']);
  const organizations = useAppSelector((state) => state.app.organizations);
  const isSmallScreen = useBreakpointValue({ base: true, md: false });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [isSmallScreen]);

  useEffect(() => {
    const unsubscribe = pubSub.subscribe('toggleNavigation', ({ isOpen }) => {
      setIsOpen(isOpen ?? !isOpen);
    });

    return () => unsubscribe();
  }, []);

  const handleToggleNavigation = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={classNames(
        styles.navigationContainer,
        {
          [styles.navigationContainerOpen]: isOpen,
        },
        className,
      )}
    >
      {isSmallScreen && (
        <Box
          className={styles.backdrop}
          aria-hidden="true"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div className={styles.navigation}>
        {organizationsSidebar && organizations.length > 1 && (
          <OrganizationsNavigation className={styles.sidebar} />
        )}

        <div className={styles.menu}>
          <Menu
            isMenuAlwaysOpen={!!isSmallScreen}
            onToggleNavigation={handleToggleNavigation}
          />
        </div>
      </div>
    </div>
  );
};
